(() => {
  'use strict';
  const page = document.querySelector('[data-referral-recipient]');
  if (!page) return;
  const button = page.querySelector('[data-referral-claim]');
  const missing = page.querySelector('[data-referral-missing]');
  const status = page.querySelector('[data-referral-status]');
  const query = new URLSearchParams(location.search);
  const intent = query.get('st_intent');
  const code = query.get('smile_referral_code') || (/^st:referrals:customer-offers:/.test(intent || '') ? intent.split(':')[3] : null);
  if (!code || !/^[a-zA-Z0-9_-]{3,100}$/.test(code)) return;
  missing.hidden = true;
  button.hidden = false;
  status.textContent = status.dataset.loading;
  let timeout;
  function ready() {
    if (!window.DACRewards?.open) return;
    clearTimeout(timeout);
    button.dataset.dlrView = 'claim:' + code;
    button.disabled = false;
    status.textContent = '';
  }
  document.addEventListener('dac:rewards-shell-ready', ready, { once: true });
  ready();
  if (button.disabled) timeout = setTimeout(() => {
    if (button.disabled) status.textContent = status.dataset.unavailable;
  }, 10000);
})();
